<template>
  <div style="position: relative;">
    <tk-button class="btn-ToBw airST_sortTitle" @click="show = true">
      <slot
        name="customDisplay"
        :sort-types="sortTypes"
        :selected-sort-type="selectedSortType"
      >
        <i class="fa fa-sort"></i>
        <span>
          {{ selectedSortType.label }}
        </span>
      </slot>
    </tk-button>
    <div
      v-show="show"
      class="airST_sortPriceModal_overlay"
      style="display: block;"
      @click.self="show = false"
    />
    <div v-show="show" class="airST_sortPriceModal" style="display: block;">
      <div class="airST_sortPriceModal_list">
        <tk-button
          v-for="sortType in sortTypes"
          :key="sortType.value"
          :class="[
            'airST_sortPriceModal_listItem',
            {
              'is-active': sortType === selectedSortType,
            },
          ]"
          @click="selectItem(sortType)"
        >
          {{ sortType.label }}
          <img
            v-show="sortType === selectedSortType"
            src="~@ota-frontend/shared-assets/images/dp/ic_check_red.svg"
            alt="arrow"
          />
        </tk-button>
      </div>
    </div>
  </div>
</template>

<script>
import TkButton from '../../atoms/TkButton/TkButton'

export default {
  name: 'TkSortBox',
  components: {
    TkButton,
  },
  props: {
    sortTypes: {
      type: Array,
      default: () => [],
      validator: (prop) =>
        !prop ||
        prop.length > 0 ||
        prop.find((el) => !el.value || !el.label) !== undefined,
    },
    defaultSortValue: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selected: null,
      show: false,
    }
  },
  computed: {
    selectedSortType() {
      let found = this.sortTypes.find((el) => el.value === this.selected)
      if (!found && this.defaultSortValue) {
        found = this.sortTypes.find((el) => el.value === this.defaultSortValue)
      }
      return found || this.sortTypes[0]
    },
  },
  methods: {
    selectItem(sortType) {
      if (this.selected !== sortType.value) {
        this.selected = sortType.value
        this.$emit('change', this.selectedSortType)
      }
      this.show = false
    },
  },
}
</script>
